import React from "react";
import RatingBar from "./RatingBar.jsx"
import RatingCircle from "./RatingCircle.jsx"
import Helper from "../functions/Helper.js";
import Modal from "react-bootstrap/Modal";
import SizeScale from '../components/SizeScale.jsx';

export default function UserReviewPopup(props){
  return(
    <Modal onHide={()=>props.hide()} show={!!props.review}>
      <Modal.Header closeButton>
        <Modal.Title>{props.review.shoe_name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.review.picture_url &&
          <div style={{marginBottom:20}}>
            <picture>
              <source
                type="image/webp"
                srcSet={Helper.create_source_set({master:props.review.picture_url,thumbnails:"1"},undefined,"webp")}
                sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                />
              <source
                type="image/png"
                srcSet={Helper.create_source_set({master:props.review.picture_url,thumbnails:"1"})}
                sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                />
              <img
                style={{
                  cursor:"zoom-in",maxHeight:150,
                  objectPosition:"bottom left",objectFit:"contain",width:"100%",height:"100%"
                }}
                src={Helper.add_options_img(props.review.picture_url,286)}
                sizes="(max-width:600px) calc(100vw-35px), (max-width:992px) 585px,(max-width: 1200px) 50vw, 585px"
                alt={"style"}
                srcSet={Helper.create_source_set({master:props.review.picture_url,thumbnails:"1"})}/>
            </picture>
          </div>
        }

        <div style={{display:"flex",alignItems:"center"}}>
          <div style={{  textAlign:"center",

          borderRadius:2,
          width: 50,
          height: 35,
          display:"flex",
          alignItems:"center",
          justifyContent:"center",
          fontWeight: 'bold',
          color: 'white',

            fontSize:18,backgroundColor:Helper.get_color(props.review.rating)}}>
            {Helper.roundto(props.review.rating,1)}
          </div>
          <div style={{marginLeft:10,fontWeight:600,fontSize:20}}>Overall Rating </div>
        </div>
        <div style={{fontSize:16,marginTop:10,marginBottom:20,}}>
          {props.review.summary==="" ?
            <div style={{fontStyle:"italic"}}>
              No summary was added
            </div>
             :
             <div style={{}}>
               {props.review.summary}
             </div>
           }
        </div>

        <div style={{marginBottom:20}}>
          <RatingBar size="small" category="Traction" rating={props.review.traction}/>
          <RatingBar size="small" category="Cushion" rating={props.review.cushion}/>
          <RatingBar size="small" category="Materials" rating={props.review.materials}/>
          <RatingBar size="small" category="Support" rating={props.review.support}/>
          <RatingBar size="small" category="Fit" rating={props.review.fit}/>
          <RatingBar size="small" category="Outdoor" rating={props.review.outdoor}/>
          <RatingBar size="small" category="Durability" rating={props.review.durability}/>
          <div style={{marginTop:10,marginBottom:props.review.width ==="-1" ? 15: 10 ,display:"flex",alignItems:"flex-end",fontSize:16}}>
              <div style={{flex:0,fontWeight:600,flexBasis:50,lineHeight:1}}>Sizing:</div>
              {props.review.size==="-1" ?
                <div style={{lineHeight:1,paddingLeft:20,fontWeight:600,color:"#555",}}>NA</div>:
                <div  style={{justifyContent:"flex-end",textAlign:"right",display:"flex",flex:2,paddingLeft:20}}>
                  <SizeScale shoe_name={props.review.shoe_name} percent={props.review.size} type="size"/>
                </div>
              }
            </div>


            <div style={{display:"flex",alignItems:"flex-end",fontSize:16}}>
              <div style={{flex:0,fontWeight:600,flexBasis:50,lineHeight:1}}>Width:</div>
              {props.review.width ==="-1" ?
                <div style={{lineHeight:1,paddingLeft:20,fontWeight:600,color:"#555",}}>NA</div>:
                <div style={{justifyContent:"flex-end",textAlign:"right",display:"flex",flex:2,paddingLeft:20}}>
                  <SizeScale shoe_name={props.review.shoe_name} percent={props.review.width} type="width"/>
                </div>
              }
            </div>
        </div>

      </Modal.Body>
    </Modal>
  )
}
